function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 2.25H6.07059L0 9.98824L12 22.9147L24 10.0941L18 2.25Z",
  fill: "url(#paint0_radial_4395_5200)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M7.125 10.125H0L6 2.25H10.125L7.125 10.125Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M16.875 10.125H24L18 2.25H13.875L16.875 10.125Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M16.875 10.125H7.125L12 22.875L16.875 10.125Z",
  fill: "white"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1151 17.3077L10.8623 12.478H7.5L13.1038 5.25L12.3566 10.0797H15.75L10.1151 17.3077Z",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_4395_5200",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(26.116 22.9584) scale(35.333 30.4193)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02E1B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#0B54FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#1152FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#204BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#3B40FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#5F31FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#8E1EFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A714FD"
})));
function SvgApower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApower);
export default __webpack_public_path__ + "static/media/apower.ad77bf24f0152f9ffe9fc7a0d7463915.svg";
export { ForwardRef as ReactComponent };